<template>
  <f7-page>
    <f7-navbar title="員工管理">
      <f7-nav-left>
        <f7-link icon-if-ios="f7:menu" icon-if-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
    </f7-navbar>

    Some information
  </f7-page>
</template>

<script>
export default {
  dependencies: [
    'platformUtils'
  ],
  data () {
    return {
      platform: process.env.VUE_APP_PLATFORM
    }
  },
  created () {
  },
  components: {
  }
}
</script>
